import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "../stores/authStore";

export function AdminRoute() {
  const { user } = useAuthStore();

  if (!user?.isAdmin) {
    return <Navigate to="/seats" replace />;
  }

  return <Outlet />;
}
